import {AwpDmsInterfaceFactoryUtils} from '../../rest-api/awp-dms-interface-factory-utils';
import {GetVehicleRequest} from './get-vehicle-request';
import {GetVehicleRequestBody} from './get-vehicle-request-body';
import {SearchVehiclesRequest} from './search-vehicles-request';
import {SearchVehiclesFilter, SearchVehiclesRequestBody} from './search-vehicles-request-body';

export class AwpDmsInterfaceVehicleRequestFactory {
  createGetVehicleRequest(vin: string, locale: string, dpNo: string, outletNo: string): GetVehicleRequest {
    const schema = 'awp-dms-get-vehicle-request';
    const version = '1.0.0';
    const request = new GetVehicleRequest();
    request.functionalHeader = AwpDmsInterfaceFactoryUtils.createFunctionalHeaderFromPrimitives(dpNo, outletNo);
    request.technicalHeader = AwpDmsInterfaceFactoryUtils.createTechnicalHeaderInRequest(schema, version);
    request.userInformation = AwpDmsInterfaceFactoryUtils.createUserInformationFromPrimitive(locale);
    request.body = new GetVehicleRequestBody();
    request.body.vin = vin;
    return request;
  }

  createSearchVehiclesRequest(searchFilter: SearchVehiclesFilter, resultPartition: number,
                              locale: string, dpNo: string, outletNo: string): SearchVehiclesRequest {
    const request = new SearchVehiclesRequest();
    const schema = 'awp-dms-search-vehicles-request';
    const version = '1.0.0';
    request.functionalHeader = AwpDmsInterfaceFactoryUtils.createFunctionalHeaderFromPrimitives(dpNo, outletNo);
    request.technicalHeader = AwpDmsInterfaceFactoryUtils.createTechnicalHeaderInRequest(schema, version);
    request.userInformation = AwpDmsInterfaceFactoryUtils.createUserInformationFromPrimitive(locale);
    request.body = new SearchVehiclesRequestBody();
    request.body.searchFilter = searchFilter;
    request.body.resultPartition = resultPartition;
    return request;
  }
}
